import {
  ToolbarContainer,
  UndoButton,
  RedoButton,
  BoldButton,
  ItalicButton,
  StrikethroughButton,
  InlineCodeButton,
  OrderedListButton,
  UnorderedListButton,
  QuoteButton,
  CodeBlockButton,
  TableButton,
  TableDropdown,
  FormulaBlockButton,
  FormulaMarkButton,
  LinkButton,
  UnderlineButton,
  TextAlignButton,
  ColorButton,
  HighlightButton,
  ImageButton,
  FontFamilyButton,
  IFrameButton,
  YoutubeButton,
  ClearFormattingButton,
  FontSizeButton,
} from '.';

interface MarkdownToolbarProps {
  enableMath?: boolean;
  enableCourseTools?: boolean;
}

export default function MarkdownToolbar({
  enableMath = false,
  enableCourseTools = false,
}: MarkdownToolbarProps) {
  return (
    <ToolbarContainer>
      <UndoButton />
      <RedoButton />
      <BoldButton />
      <ItalicButton />
      <StrikethroughButton />
      {enableCourseTools && (
        <>
          <LinkButton />
          <UnderlineButton />
          <TextAlignButton />
          <ColorButton />
          <HighlightButton />
          <FontFamilyButton />
          <FontSizeButton />
          <ClearFormattingButton />
          <ImageButton />
          <YoutubeButton />
          <IFrameButton />
        </>
      )}
      <InlineCodeButton />
      <OrderedListButton />
      <UnorderedListButton />
      <QuoteButton />
      <TableButton />
      <TableDropdown />
      <CodeBlockButton />
      {enableMath && (
        <>
          <FormulaBlockButton />
          <FormulaMarkButton />
        </>
      )}
    </ToolbarContainer>
  );
}
